import axios from 'axios'

export const all = (year: number): Promise<any> => axios.get('dashboard', {
  params: {
    year,
  },
})
